import { call, put, takeLatest } from "redux-saga/effects";
import { GET_AutomationList, POST_AutomationToggle, POST_Automation, PUT_Automation, DELETE_Automation } from "../services/Automation";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_AutomationListEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_AutomationList, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_AutomationList", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_AutomationToggleEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(POST_AutomationToggle, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_AutomationEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(POST_Automation, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_AutomationEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(PUT_Automation, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_AutomationEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(DELETE_Automation, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* AutomationSaga() {
  yield takeLatest("GET_AutomationList", GET_AutomationListEffect);
  yield takeLatest("POST_AutomationToggle", POST_AutomationToggleEffect);
  yield takeLatest("POST_Automation", POST_AutomationEffect);
  yield takeLatest("PUT_Automation", PUT_AutomationEffect);
  yield takeLatest("DELETE_Automation", DELETE_AutomationEffect);
}
